"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpoints = void 0;
exports.breakpoints = {
    values: {
        xs: 0,
        mobileXs: 320,
        mobileSm: 375,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
    },
};
//# sourceMappingURL=breakpoints.js.map